export default "__VITE_ASSET__Xp6xiMs4__"